import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  collaboration = 'collaboration',
  collaborativeDocument = 'collaborativeDocument',
}

export const collaborationRouteRef = createRouteRef({
  id: RoutesIds.collaboration,
});

export const rootRouteRef = collaborationRouteRef;

export const collaborativeDocumentRouteRef = createSubRouteRef({
  id: RoutesIds.collaborativeDocument,
  parent: rootRouteRef,
  path: '/:id',
});

export const Routes = {
  collaboration: collaborationRouteRef,
  collaborativeDocument: collaborativeDocumentRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {} satisfies Record<string, ExternalRouteRef>;
